<template>
  <a-form-model
      ref="targetForm"
      :model="form"
      :rules="rules"
      :label-col="{span: 12}"
      :wrapper-col="{span: 12}"
  >
    <a-card title="个人信息">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="是否有曾有名" prop="otherName">
            <a-radio-group v-model="form.otherName">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.otherName === 'Yes'">
          <a-form-model-item label="姓氏(曾有名)" prop="otherSurname">
            <a-input placeholder="例如 li" v-model="form.otherSurname"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.otherName === 'Yes'">
          <a-form-model-item label="名字(曾有名)" prop="otherGivenName">
            <a-input placeholder="例如 xinan" v-model="form.otherGivenName"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-card>
    <a-card title="联系信息" style="margin-top: 24px">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="现居住地址" prop="homeAddress">
            <a-input placeholder="例如 广东省 广州市 白云区 珠江新城01号" v-model="form.homeAddress"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="手机号" prop="phoneNumber">
            <a-input addon-before="+86" v-model="form.phoneNumber" placeholder="例如 13900000000"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="邮箱" prop="email">
            <a-input placeholder="例如 xxx@gmail.com" v-model="form.email"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="紧急联系人姓名" prop="contactName">
            <a-input placeholder="张某某" v-model="form.contactName"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="紧急联系人国家" prop="contactCountry">
            <a-input placeholder="中国" v-model="form.contactCountry"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="紧急联系人手机号" prop="contactPhoneNumber">
            <a-input addon-before="+86" v-model="form.contactPhoneNumber" placeholder="例如 13900000000"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="紧急联系人与你关系" prop="contactRelationship">
            <a-input placeholder="朋友" v-model="form.contactRelationship"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-card>
    <a-card title="婚姻状况及家庭成员信息" style="margin-top: 24px">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="婚姻状况" prop="maritalStatus">
            <a-select v-model="form.maritalStatus" placeholder="请选择">
              <a-select-option value="SINGLE">单身</a-select-option>
              <a-select-option value="MARRIED">已婚</a-select-option>
              <a-select-option value="DIVORCED">离异</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="配偶姓氏" prop="spouseSurname">
            <a-input placeholder="例如 zhang" v-model="form.spouseSurname"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="配偶名字" prop="spouseGivenName">
            <a-input placeholder="例如 san" v-model="form.spouseGivenName"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="配偶出生日期" prop="spouseDateOfBirth">
            <a-date-picker style="width: 100%" v-model="form.spouseDateOfBirth" :disabled-date="afterNow"
                           value-format="YYYY-MM-DD"
            />
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="配偶国家" prop="spouseCountry">
            <a-input placeholder="中国" v-model="form.spouseCountry"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="配偶居住地" prop="spouseAddress">
            <a-input placeholder="例如 广东省 广州市 白云区 珠江新城01号" v-model="form.spouseAddress"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="联系电话" prop="spousePhoneNumber">
            <a-input addon-before="+86" v-model="form.spousePhoneNumber" placeholder="例如 13900000000"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="子女人数" prop="sonNum">
            <a-input-number :min="0" placeholder="子女人数" style="width: 100%" v-model="form.sonNum"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-card>
    <a-card title="学历信息" style="margin-top: 24px">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="最高学历" prop="degree">
            <a-select v-model="form.degree" placeholder="请选择">
              <a-select-option value="Master">硕士/博士</a-select-option>
              <a-select-option value="Bachelor">学士</a-select-option>
              <a-select-option value="High">高中</a-select-option>
              <a-select-option value="Other">其他</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="学校名称" prop="schoolName">
            <a-input placeholder="例如 zhang" v-model="form.schoolName"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="学校地址" prop="schoolAddress">
            <a-input placeholder="例如 广东省 广州市 白云区 珠江新城01号" v-model="form.schoolAddress"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-card>
    <a-card title="职业信息" style="margin-top: 24px">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="当前职业" prop="circumstances">
            <a-select v-model="form.circumstances" placeholder="请选择">
              <a-select-option value="事业家">事业家</a-select-option>
              <a-select-option value="自顾">自顾</a-select-option>
              <a-select-option value="公司职员">公司职员</a-select-option>
              <a-select-option value="公务员">公务员</a-select-option>
              <a-select-option value="学生">学生</a-select-option>
              <a-select-option value="退休">退休</a-select-option>
              <a-select-option value="无业">无业</a-select-option>
              <a-select-option value="其他">其他</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.circumstances === '其他'">
          <a-form-model-item label="其他说明" prop="otherDetails">
            <a-input placeholder="如其他,请详细说明" v-model="form.otherDetails"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="公司/机关/学校名称" prop="companyName">
            <a-input placeholder="例如 apple" v-model="form.companyName"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="职位/课程" prop="companyPosition">
            <a-input placeholder="例如 manager" v-model="form.companyPosition"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="公司/机关/学校地址" prop="companyAddress">
            <a-input placeholder="例如 广东省 广州市 白云区 珠江新城01号" v-model="form.companyAddress"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="联系电话" prop="companyPhoneNumber">
            <a-input addon-before="+86" v-model="form.companyPhoneNumber" placeholder="例如 13900000000"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-card>
    <a-card title="访问信息" style="margin-top: 24px">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="入境事由" prop="purpose">
            <a-select v-model="form.purpose" placeholder="请选择">
              <a-select-option value="旅游/过境">旅游/过境</a-select-option>
              <a-select-option value="参加会议等活动">参加会议等活动</a-select-option>
              <a-select-option value="医疗旅游">医疗旅游</a-select-option>
              <a-select-option value="短期商务">短期商务</a-select-option>
              <a-select-option value="学习/培训">学习/培训</a-select-option>
              <a-select-option value="就业活动">就业活动</a-select-option>
              <a-select-option value="贸易/投资/派驻">贸易/投资/派驻</a-select-option>
              <a-select-option value="探亲访友">探亲访友</a-select-option>
              <a-select-option value="结婚移民">结婚移民</a-select-option>
              <a-select-option value="外交/公务">外交/公务</a-select-option>
              <a-select-option value="其他">其他</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.purpose === '其他'">
          <a-form-model-item label="其他说明" prop="purposeDetails">
            <a-input placeholder="如其他,请详细说明" v-model="form.purposeDetails"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="拟滞留天数" prop="intendedStay">
            <a-input-number :min="0" placeholder="拟滞留天数" style="width: 100%" v-model="form.intendedStay"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="拟入境日期" prop="entryDate">
            <a-date-picker style="width: 100%" v-model="form.entryDate" :disabled-date="beforeNow"
                           value-format="YYYY-MM-DD"
            />
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="在韩滞留地址" prop="addressInKorea">
            <a-input placeholder="酒店" v-model="form.addressInKorea"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="在韩联系电话" prop="phoneInKorea">
            <a-input v-model="form.phoneInKorea" placeholder="例如 13900000000"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="过去访问韩国目的1" prop="purposeOfVisit1">
            <a-input v-model="form.purposeOfVisit1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="访问期间1" prop="periodOfStay1">
            <a-range-picker style="width: 100%" v-model="form.periodOfStay1" value-format="YYYY-MM-DD"
                            :placeholder="['开始日期', '结束日期']" :inputReadOnly="true" :disabled-date="afterNow"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.visitKoreaRecord2 || form.visitKoreaRecord2 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addVisitKoreaRecord(2)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.visitKoreaRecord2 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="过去访问韩国目的2" prop="purposeOfVisit2">
            <a-input v-model="form.purposeOfVisit2"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="访问期间2" prop="periodOfStay2">
            <a-range-picker style="width: 100%" v-model="form.periodOfStay2" value-format="YYYY-MM-DD"
                            :placeholder="['开始日期', '结束日期']" :inputReadOnly="true" :disabled-date="afterNow"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.visitKoreaRecord3 || form.visitKoreaRecord3 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addVisitKoreaRecord(3)"/>
            <a-icon class="dynamic-delete-button" type="minus-circle" @click="removeVisitKoreaRecord(2)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.visitKoreaRecord3 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="过去访问韩国目的3" prop="purposeOfVisit3">
            <a-input v-model="form.purposeOfVisit3"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="访问期间3" prop="periodOfStay3">
            <a-range-picker style="width: 100%" v-model="form.periodOfStay3" value-format="YYYY-MM-DD"
                            :placeholder="['开始日期', '结束日期']" :inputReadOnly="true" :disabled-date="afterNow"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item>
            <a-icon class="dynamic-delete-button" type="minus-circle" @click="removeVisitKoreaRecord(3)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="过去访问其他国家1" prop="countryNameVisit1">
            <a-input placeholder="美国" v-model="form.countryNameVisit1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="访问目的1" prop="countryPurposeVisit1">
            <a-input v-model="form.countryPurposeVisit1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="访问期间1" prop="countryStayVisit1">
            <a-range-picker style="width: 100%" v-model="form.countryStayVisit1" value-format="YYYY-MM-DD"
                            :placeholder="['开始日期', '结束日期']" :inputReadOnly="true" :disabled-date="afterNow"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.visitCountryRecord2 || form.visitCountryRecord2 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addVisitCountryRecord(2)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.visitCountryRecord2 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="过去访问其他国家2" prop="countryNameVisit2">
            <a-input placeholder="美国" v-model="form.countryNameVisit2"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="访问目的2" prop="countryPurposeVisit2">
            <a-input v-model="form.countryPurposeVisit2"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="访问期间2" prop="countryStayVisit2">
            <a-range-picker style="width: 100%" v-model="form.countryStayVisit2" value-format="YYYY-MM-DD"
                            :placeholder="['开始日期', '结束日期']" :inputReadOnly="true" :disabled-date="afterNow"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.visitKoreaRecord3 || form.visitKoreaRecord3 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addVisitCountryRecord(3)"/>
            <a-icon class="dynamic-delete-button" type="minus-circle" @click="removeVisitCountryRecord(2)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.visitCountryRecord3 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="过去访问其他国家3" prop="countryNameVisit3">
            <a-input placeholder="美国" v-model="form.countryNameVisit3"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="访问目的3" prop="countryPurposeVisit3">
            <a-input v-model="form.countryPurposeVisit3"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="访问期间3" prop="countryStayVisit3">
            <a-range-picker style="width: 100%" v-model="form.countryStayVisit3" value-format="YYYY-MM-DD"
                            :placeholder="['开始日期', '结束日期']" :inputReadOnly="true" :disabled-date="afterNow"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item>
            <a-icon class="dynamic-delete-button" type="minus-circle" @click="removeVisitCountryRecord(3)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="滞留韩国家人姓名1" prop="familyKorea1">
            <a-input placeholder="家人:配偶,子女,父母,兄弟姐妹" v-model="form.familyKorea1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="出生日期1" prop="familyBirthdayKorea1">
            <a-date-picker style="width: 100%" v-model="form.familyBirthdayKorea1" :disabled-date="afterNow"
                           value-format="YYYY-MM-DD"
            />
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="国家1" prop="familyCountryKorea1">
            <a-input placeholder="美国" v-model="form.familyCountryKorea1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="与申请人关系1" prop="familyRelationshipKorea1">
            <a-input placeholder="兄弟" v-model="form.familyRelationshipKorea1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.stayFamilyRecord2 || form.stayFamilyRecord2 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addStayFamilyRecord(2)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.stayFamilyRecord2 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="滞留韩国家人姓名2" prop="familyKorea2">
            <a-input placeholder="家人:配偶,子女,父母,兄弟姐妹" v-model="form.familyKorea2"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="出生日期2" prop="familyBirthdayKorea2">
            <a-date-picker style="width: 100%" v-model="form.familyBirthdayKorea2" :disabled-date="afterNow"
                           value-format="YYYY-MM-DD"
            />
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="国家2" prop="familyCountryKorea2">
            <a-input placeholder="美国" v-model="form.familyCountryKorea2"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="与申请人关系2" prop="familyRelationshipKorea2">
            <a-input placeholder="兄弟" v-model="form.familyRelationshipKorea2"/>
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.stayFamilyRecord3 || form.stayFamilyRecord3 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addStayFamilyRecord(3)"/>
            <a-icon class="dynamic-delete-button" type="minus-circle" @click="removeStayFamilyRecord(2)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.stayFamilyRecord3 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="滞留韩国家人姓名3" prop="familyKorea3">
            <a-input placeholder="家人:配偶,子女,父母,兄弟姐妹" v-model="form.familyKorea3"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="出生日期3" prop="familyBirthdayKorea3">
            <a-date-picker style="width: 100%" v-model="form.familyBirthdayKorea3" :disabled-date="afterNow"
                           value-format="YYYY-MM-DD"
            />
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="国家3" prop="familyCountryKorea3">
            <a-input placeholder="美国" v-model="form.familyCountryKorea3"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="与申请人关系3" prop="familyRelationshipKorea3">
            <a-input placeholder="兄弟" v-model="form.familyRelationshipKorea3"/>
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item>
            <a-icon class="dynamic-delete-button" type="minus-circle" @click="removeStayFamilyRecord(3)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="偕行韩国家人姓名1" prop="familyVisit1">
            <a-input placeholder="家人:配偶,子女,父母,兄弟姐妹" v-model="form.familyVisit1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="出生日期1" prop="familyBirthdayVisit1">
            <a-date-picker style="width: 100%" v-model="form.familyBirthdayVisit1" :disabled-date="afterNow"
                           value-format="YYYY-MM-DD"
            />
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="国家1" prop="familyCountryVisit1">
            <a-input placeholder="美国" v-model="form.familyCountryVisit1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="与申请人关系1" prop="familyRelationshipVisit1">
            <a-input placeholder="兄弟" v-model="form.familyRelationshipVisit1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.visitFamilyRecord2 || form.visitFamilyRecord2 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addVisitFamilyRecord(2)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.visitFamilyRecord2 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="偕行韩国家人姓名2" prop="familyVisit2">
            <a-input placeholder="家人:配偶,子女,父母,兄弟姐妹" v-model="form.familyVisit2"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="出生日期2" prop="familyBirthdayVisit2">
            <a-date-picker style="width: 100%" v-model="form.familyBirthdayVisit2" :disabled-date="afterNow"
                           value-format="YYYY-MM-DD"
            />
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="国家2" prop="familyCountryVisit2">
            <a-input placeholder="美国" v-model="form.familyCountryVisit2"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="与申请人关系2" prop="familyRelationshipVisit2">
            <a-input placeholder="兄弟" v-model="form.familyRelationshipVisit2"/>
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.visitFamilyRecord3 || form.visitFamilyRecord3 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addVisitFamilyRecord(3)"/>
            <a-icon class="dynamic-delete-button" type="minus-circle" @click="removeVisitFamilyRecord(2)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.visitFamilyRecord3 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="偕行韩国家人姓名3" prop="familyVisit3">
            <a-input placeholder="家人:配偶,子女,父母,兄弟姐妹" v-model="form.familyVisit3"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="出生日期3" prop="familyBirthdayVisit3">
            <a-date-picker style="width: 100%" v-model="form.familyBirthdayVisit3" :disabled-date="afterNow"
                           value-format="YYYY-MM-DD"
            />
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="国家3" prop="familyCountryVisit3">
            <a-input placeholder="美国" v-model="form.familyCountryVisit3"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="与申请人关系3" prop="familyRelationshipVisit3">
            <a-input placeholder="兄弟" v-model="form.familyRelationshipVisit3"/>
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item>
            <a-icon class="dynamic-delete-button" type="minus-circle" @click="removeVisitFamilyRecord(3)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-card>
    <a-card title="在韩邀请方信息" style="margin-top: 24px">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="在韩邀请人或单位" prop="koreaCompanyName">
            <a-input placeholder="例如 sunsamg" v-model="form.koreaCompanyName"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="出生日期或事业者登记证号码" prop="koreaCompanyBirthday">
            <a-input placeholder="" v-model="form.koreaCompanyBirthday"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="与申请人关系" prop="koreaCompanyRelationship">
            <a-input placeholder="顾客" v-model="form.koreaCompanyRelationship"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="地址" prop="koreaCompanyAddress">
            <a-input placeholder="" v-model="form.koreaCompanyAddress"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="联系电话" prop="koreaCompanyPhoneNumber">
            <a-input v-model="form.koreaCompanyPhoneNumber" placeholder="例如 13900000000"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-card>
    <a-card title="费用信息" style="margin-top: 24px">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="在韩期间费用($)" prop="travelCoast">
            <a-input placeholder="例如 10000" v-model="form.travelCoast"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="支付费用人或单位" prop="payCompanyName">
            <a-input placeholder="例如 sunsamg" v-model="form.payCompanyName"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="与申请人关系" prop="payCompanyRelationship">
            <a-input placeholder="雇佣" v-model="form.payCompanyRelationship"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="类别" prop="payCompanyType">
            <a-input placeholder="" v-model="form.payCompanyType"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="联系电话" prop="payCompanyPhoneNumber">
            <a-input v-model="form.payCompanyPhoneNumber" placeholder="例如 13900000000"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-card>
    <a-card title="证件照上传" style="margin-top: 24px">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="证件照">
            <a-upload
                name="file"
                v-model="form.avatarImgUrl"
                list-type="picture-card"
                class="avatar-uploader"
                :show-upload-list="false"
                :action="url.upload"
                :data="{bucket: 'esvisa', bizPath: 'avatar'}"
                :headers="this.headersWithoutJson"
                :before-upload="beforeUpload"
                @change="handleChange">
              <img v-if="form.avatarImgUrl" :src="form.avatarImgUrl" alt="avatar" width="100px"/>
              <div v-else>
                <a-icon :type="avatarImg.loading ? 'loading' : 'plus'"/>
                <div class="ant-upload-text">
                  上传
                </div>
              </div>
            </a-upload>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-card>
  </a-form-model>
</template>

<script>

import moment from 'moment';
import 'moment/locale/zh-cn';
import {HttpMixins} from "@/mixins/http-mixins";

const pattern = {
  english: /^[A-Za-z]+( [A-Za-z]+)*$/,
  nationalIdentification: /^(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)|(^([A-Z]|[0-9]){5,17}$)$/,
  zipCode: /^([0-9]\d{4,5})$/,
  cellphone: /^(1[345789]\d{9})$/,
  phone: /^(\d{11,12})$/,
  mail: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
  passportNumber: /^([A-Z]|[0-9]){5,17}$/,
  numberOrEnglish: /^([A-Za-z0-9 ]*)$/,
  numberOrChinaOrEnglish: /^([\u4E00-\u9FA5\w\- ]+)$/,
  number: /^([0-9]*)$/,
}


export default {
  name: "DetailCreateTable",
  mixins: [HttpMixins],
  data() {
    return {
      moment,
      model: {},
      form: {},
      avatarImg: {
        loading: false,
        name: 'avatarImgUrl',
      },
      rules: {
        otherName: [],
        otherSurname: [],
        otherGivenName: [],
        homeAddress: [],
        phoneNumber: [],
        email: [{pattern: pattern.mail, message: '输入有误,请检查!'}],
        contactName: [],
        contactCountry: [],
        contactPhoneNumber: [],
        contactRelationship: [],
        maritalStatus: [],
        spouseSurname: [],
        spouseGivenName: [],
        spouseDateOfBirth: [],
        spouseCountry: [],
        spouseAddress: [],
        spousePhoneNumber: [],
        sonNum: [],
        degree: [],
        schoolName: [],
        schoolAddress: [],
        circumstances: [],
        otherDetails: [],
        companyName: [],
        companyPosition: [],
        companyAddress: [],
        companyPhoneNumber: [],
        purpose: [],
        purposeDetails: [],
        intendedStay: [],
        entryDate: [],
        addressInKorea: [],
        phoneInKorea: [],
        purposeOfVisit1: [],
        periodOfStay1: [],
        purposeOfVisit2: [],
        periodOfStay2: [],
        purposeOfVisit3: [],
        periodOfStay3: [],
        countryNameVisit1: [],
        countryPurposeVisit1: [],
        countryStayVisit1: [],
        countryNameVisit2: [],
        countryPurposeVisit2: [],
        countryStayVisit2: [],
        countryNameVisit3: [],
        countryPurposeVisit3: [],
        countryStayVisit3: [],
        familyKorea1: [],
        familyBirthdayKorea1: [],
        familyCountryKorea1: [],
        familyRelationshipKorea1: [],
        familyKorea2: [],
        familyBirthdayKorea2: [],
        familyCountryKorea2: [],
        familyRelationshipKorea2: [],
        familyKorea3: [],
        familyBirthdayKorea3: [],
        familyCountryKorea3: [],
        familyRelationshipKorea3: [],
        familyVisit1: [],
        familyBirthdayVisit1: [],
        familyCountryVisit1: [],
        familyRelationshipVisit1: [],
        familyVisit2: [],
        familyBirthdayVisit2: [],
        familyCountryVisit2: [],
        familyRelationshipVisit2: [],
        familyVisit3: [],
        familyBirthdayVisit3: [],
        familyCountryVisit3: [],
        familyRelationshipVisit3: [],
        koreaCompanyName: [],
        koreaCompanyBirthday: [],
        koreaCompanyRelationship: [],
        koreaCompanyAddress: [],
        koreaCompanyPhoneNumber: [],
        travelCoast: [],
        payCompanyName: [],
        payCompanyRelationship: [],
        payCompanyType: [],
        payCompanyPhoneNumber: [],
        avatarImgUrl: []
      },
      url: {
        complement: window._CONFIG['domainURL'] + "/krDs/complement",
        draftSave: window._CONFIG['domainURL'] + "/power/krDs/draftSave",
        upload: window._CONFIG['domainURL'] + "/power/uploadFile"
      }
    }
  },
  methods: {
    beforeNow(current) {
      return current && current < moment().startOf('day');
    },
    afterNow(current) {
      return current && current > moment().startOf('day');
    },
    addVisitKoreaRecord(i) {
      this.$set(this.form, ['visitKoreaRecord' + i], 'Yes');
    },
    removeVisitKoreaRecord(i) {
      this.$set(this.form, ['visitKoreaRecord' + i], 'No');
    },
    addVisitCountryRecord(i) {
      this.$set(this.form, ['visitCountryRecord' + i], 'Yes');
    },
    removeVisitCountryRecord(i) {
      this.$set(this.form, ['visitCountryRecord' + i], 'No');
    },
    addStayFamilyRecord(i) {
      this.$set(this.form, ['stayFamilyRecord' + i], 'Yes');
    },
    removeStayFamilyRecord(i) {
      this.$set(this.form, ['stayFamilyRecord' + i], 'No');
    },
    addVisitFamilyRecord(i) {
      this.$set(this.form, ['visitFamilyRecord' + i], 'Yes');
    },
    removeVisitFamilyRecord(i) {
      this.$set(this.form, ['visitFamilyRecord' + i], 'No');
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.avatarImg.loading = true;
        this.$set(this.form, this.avatarImg.name, '');
      }
      if (info.file.status === 'done') {
        this.avatarImg.loading = false;
        let response = info.file.response;
        if (response.code === 200) {
          this.$set(this.form, this.avatarImg.name, response.data.url);
        }
      }
      if (info.file.status === 'error') {
        this.avatarImg.loading = false;
      }
    },
    beforeUpload(file) {
      let that = this;
      const isJpg = file.type === 'image/jpeg';
      if (!isJpg) {
        that.$message.error('只支持上传 JPG 格式!');
        return false;
      }
      const isLt200kb = file.size / 1024 < 800;
      if (!isLt200kb) {
        that.$message.error('证件文件大小必须小于 800KB!');
        return false;
      }
      const isSize = new Promise(function (resolve, reject) {
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function () {
          let valid = img.width < 2400 && img.height < 2400;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      }).then(
          () => {
            return file;
          },
          () => {
            that.$message.error('上传图片分辨率要小于2400*2400px!');
            return Promise.reject();
          });
      return isSize;
    },
    handleDraft() {
      const that = this;
      that.model.content = JSON.stringify(that.form);
      that.$axios.put(that.url.draftSave, that.model, {headers: that.headers})
          .then((res) => {
            let response = res.data;
            if (response.code === 200) {
              that.$message.success(response.msg);
              that.$emit('completeDraft');
            } else {
              that.$message.error(response.msg);
            }
          })
          .catch((error) => {
            that.catchError(error);
          });
    },
    init(data) {
      this.$refs.targetForm.clearValidate();
      this.model = Object.assign({}, data);
      this.form = {};
      if (this.model.content) {
        this.form = JSON.parse(this.model.content);
      }
    },
    handleValid() {
      this.$refs.targetForm.validate((valid) => {
        if (valid) {
          this.$message.success("验证通过")
          return;
        }
        this.$message.warning("验证不通过")
      })
    },
  }
}
</script>

<style scoped>

.dynamic-add-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #87d068;
  transition: all 0.3s;
  margin-left: 20px;
}

.dynamic-add-button:hover {
  color: #26cc2a;
}

.dynamic-add-button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}

.dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #999;
  transition: all 0.3s;
  margin-left: 20px;
}

.dynamic-delete-button:hover {
  color: #777;
}

.dynamic-delete-button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}

</style>
